import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    // { key: 'id', sortable: true },
    { key: 'name', label: 'name', sortable: true },
    { key: 'inn', label: 'STIR', sortable: true },
    { key: 'org_admin', label: 'Admin', sortable: true },
    // { key: 'short_name', label: 'Short Name', sortable: true },
    { key: 'address', label: 'Address', sortable: true },
    { key: 'tel', label: 'Tell', sortable: true },
    { key: 'type_org', label: 'Type Org', sortable: true },
    { key: 'region_name', label: 'Location area', sortable: true },
    { key: 'parent', label: 'Higher org', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('organization', { endpoint: 'organization/organizations' }),
  }
}
